import React, { useContext } from 'react';
import { DragServiceGable } from '../../services/CabinetService/DragServiceGable';
import { EditorContext } from '../EditorCommon/EditorContext';
import { HorizontalRuler } from './HorizontalRuler';


export function GableWidthRulers(props: {

}) {


    const ec = useContext(EditorContext);
    const gables = ec.cabinet.interiorItems.filter(ii => {
        const product = ec.cabinetService.interior.getProduct(ii.productId);
        return DragServiceGable.acceptable(product.productSubGroup)
    });


    return (
        <g className="gable-width-rulers">
            {gables.map(gable => (
                <HorizontalRuler length={gable.size.x} x={gable.position.x} key={gable.index} svgY={0} />
            ))}
        </g>
    );
}
